import React from 'react';

import { Checkbox, Divider } from 'antd';

import SendValues from '../SendValues';

interface IProps {
  handlePageChange: (name: string) => () => void;
  handleRadioChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCustomValue: (value: any, number: any) => void;
  handleSendCampaign: () => void;
  handleBankslipPurchase: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checkCustomValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
  state: IPropsState;
}

interface IPropsState {
  id: string;
  step: number;
  advanced: boolean;
  platformId: number;
  platformType: string;
  hasCampaign: boolean;
  hasPrice: boolean;
  hasBankslipPurchase: boolean;
  bankslipPurchase: string;
  pixel: string;
  registered: string[];
  isFetching: boolean;
  tracker: any;
  pages: string[];
  paymentMethods: {
    credit_card: number;
    bankslip: number;
    paypal: number;
    pix: number;
  };
  purchaseValue: string;
  sendCampaign: boolean;
  conversionLabel: string;
}

const pagesCheckboxRender = [
  {
    label: 'Página do Checkout',
    key: 'checkout'
  },
  {
    label: 'Página de Obrigado (Cartão)',
    key: 'thank_you_card'
  },
  {
    label: 'Página de Obrigado (Boleto)',
    key: 'thank_you_bankslip'
  },
  {
    label: 'Visualização do Boleto',
    key: 'bankslip_view'
  }
];

function Advanced({
  state,
  handlePageChange,
  handleSendCampaign,
  handleRadioChange,
  handleCustomValue,
  checkCustomValue
}: IProps) {
  if (!state.advanced) return null;

  return (
    <div>
      <div className='[&>label]:font-medium'>
        <label className='mb-2 block font-medium'>Escolha em quais páginas vai ativar seu pixel</label>
        <div className='flex flex-col gap-2'>
          {pagesCheckboxRender.map(pageCheckbox => (
            <Checkbox
              key={pageCheckbox.key}
              checked={Boolean(state.pages.includes(pageCheckbox.key))}
              onChange={handlePageChange(pageCheckbox.key) as any}
            >
              {pageCheckbox.label}
            </Checkbox>
          ))}
        </div>
      </div>

      <Divider />

      {state.hasCampaign && (
        <>
          <div className='[&>label]:font-medium'>
            <label className='mb-2 block font-medium'>Campanhas</label>
            <Checkbox checked={state.sendCampaign} onChange={handleSendCampaign as any}>
              Sempre informar a campanha de origem
            </Checkbox>
          </div>
          <Divider />
        </>
      )}

      {state.hasBankslipPurchase && (
        <>
          <div className='[&>label]:font-medium'>
            <label className='mb-2 block font-medium'>Vendas de Boleto</label>
            <Checkbox checked disabled>
              Sempre enviar evento Purchase no boleto
            </Checkbox>
          </div>
          <p className='text-text-secondary mb-[9px]! text-[0.8rem]'>
            Não podemos enviar o evento de <b>&quot;Purchase após o boleto ser pago&quot;</b>, pois fere os{' '}
            <a href='https://www.facebook.com/about/privacy' target='_blank' rel='noopener noreferrer'>
              Termos de Privacidade do Facebook
            </a>
            . Para parar de receber o evento, desmarque a opção <b>&quot;Página de Obrigado (Boleto)&quot;</b> em{' '}
            <b>&quot;Escolha em quais páginas vai ativar seu pixel&quot;</b> nesse formulário.
          </p>

          <Divider />
        </>
      )}

      {state.hasPrice && (
        <>
          <SendValues
            state={state}
            handleRadioChange={handleRadioChange}
            handleCustomValue={handleCustomValue}
            checkCustomValue={checkCustomValue}
          />
          <Divider />
        </>
      )}
    </div>
  );
}

export default Advanced;
